import styled from 'styled-components';

const ButtonDiv = styled.div`
    width: 6rem;
    margin-left: 0.5rem;
    margin-top: 2rem;
`;

export default ButtonDiv;
